import {newSpecPage} from '@stencil/core/testing';
import {UserCard} from '../../JoyUserCard/user-card';
import {JoyAvatar} from '../../JoyAvatar/avatar';

it('renders a basic user card with fullname, subtitle and avatar, given props only', async () => {
    const page = await newSpecPage({
        components: [UserCard, JoyAvatar],
        html: `
            <joy-user-card 
                full-name="Tom Hanks"
                sub-title="This is a description"
                rating-value="4"
                photo-url="https://globalnews.ca/wp-content/uploads/2018/08/gettyimages-903462776.jpg?w=100">    
            </joy-user-card>
        `,
    });

    const avatar = page.root?.shadowRoot?.querySelector('joy-avatar');
    const title = page.root?.shadowRoot?.querySelector('.joy-user-card__title')!;
    const subtitle = page.root?.shadowRoot?.querySelector('.joy-user-card__subtitle')!;
    const rating = page.root?.shadowRoot?.querySelector('joy-rating-stars')!;

    expect(avatar).not.toBe(null);
    expect(rating).not.toBe(null);
    expect(title.textContent).toBe('Tom Hanks');
    expect(subtitle.textContent).toBe('This is a description');
});
